import styled from "styled-components"

export const MainDiv = styled.div`
    display: flex;
    height: 100vh;
    :nth-child(1) {
        flex-grow: 1;
    }
    :nth-child(2) {
        flex-grow: 2;
    }
`

export const Sidebar = styled.div`
    display: flex;
    flex: auto;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-y: auto;
    background: ${({ theme }) => theme.color.background.l};
    align-items: flex-start;
    min-width: max-content;
    max-width: max-content;
    :nth-child(1) {
        padding-left: 20px;
    }
    :first-child {
        padding-top: 20px;
    }
    :last-child {
        padding-bottom: 20px;
    }
    h1 {
        font-size: ${({ theme }) => theme.font.size.xxl};
        padding-right: 20px;
    }
    h2 {
        font-size: ${({ theme }) => theme.font.size.xl};
    }
    h3 {
        font-size: ${({ theme }) => theme.font.size.l};
    }
    p {
        max-width: 80vw;
    }
    ul {
        padding: 20px;
        li {
            padding-top: 5px;
        }
    }
`

export const Column = styled.div`
    display: flex;
    flex: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    h1 {
        font-size: ${({ theme }) => theme.font.size.xxl};
        padding: 20px;
    }
    h2 {
        font-size: ${({ theme }) => theme.font.size.xl};
        padding: 20px;
    }
    h3 {
        font-size: ${({ theme }) => theme.font.size.l};
        padding: 20px;
    }
    p {
        max-width: 80vw;
    }
`
export const Button = styled.button`
    background: rgb(105, 119, 140);
    border-radius: 3px;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    :hover {
        background: rgb(143, 157, 177);
    }
`

export const SmallButton = styled(Button)`
    padding-top: 2px;
    padding-bottom: 2px;
    margin-top: 2px;
    margin-bottom: 2px;
    min-width: 60px;
`

export const RedButton = styled(Button)`
    background: #d7674e;
    :hover {
        background: #e75f41;
    }
`



// WEBPACK FOOTER //
// ./src/OctoprintParser/styles.js